import SingleSelect from 'emerald-ui/lib/SingleSelect';
import Button from 'emerald-ui/lib/Button';
import populateDocs from './utils/populateDocs';

import { useForm, Controller } from 'react-hook-form';

let zIndex = 1000;

function getZIndex() {
  zIndex -= 1;
  return zIndex;
}

export default {
  ...populateDocs([{ component: SingleSelect, componentName: 'SingleSelect' }], 'SingleSelect'),
  description: 'Used for choosing an item from a list via a dropdown menu.',
  codeSamples: [
    {
      title: 'Default',
      scope: { SingleSelect },
      whiteBackground: true,
      style: { zIndex: getZIndex() },
      code: `<SingleSelect label="Label" id="s1">
  <option value="first">First</option>
  <option value="second">Second</option>
  <option value="third">Third</option>
  <option value="fourth">Fourth</option>
  <option value="fifth" disabled tooltip="This is a tooltip">Fifth</option>
</SingleSelect>`,
    },
    {
      title: 'With custom options',
      scope: { SingleSelect },
      whiteBackground: true,
      style: { zIndex: getZIndex() },
      code: `<SingleSelect label="Label" id="s1">
  <option key="1" value="default" captionText="default">
    <div ariaLabel="Default">
      <span className="eui-status-indicator eui-status-indicator-default" />{' '}
      Default
    </div>
  </option>
  <option key="2" value="info" captionText="info">
    <div ariaLabel="Info">
      <span className="eui-status-indicator eui-status-indicator-info" />{' '}
      Info
    </div>
  </option>
</SingleSelect>`,
    },
    {
      title: 'With react-hook-form',
      scope: { SingleSelect, useForm, Controller, Button },
      whiteBackground: true,
      code: `// import { useForm, Controller } from 'react-hook-form';

function WithReactHookForm() {
  const { control, handleSubmit, errors } = useForm();

  const onSubmit = data => {
    console.log('Form data', data);
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <Controller
        name="firstOption"
        control={control}
        defaultValue=""
        render={
          ({ onChange, value }) => (
            <SingleSelect
              onSelect={onChange}
              value={value}
              label="First"
              placeholder="Select..."
              errorMessage={errors.firstOption && errors.firstOption.message}
            >
              <option value="first">First</option>
              <option value="second">Second</option>
              <option value="third">Third</option>
            </SingleSelect>
          )
        }
        rules={{ required: 'This field is required' }}
      />
      <Controller
        name="secondOption"
        control={control}
        defaultValue="fifth"
        render={
          ({ onChange, value }) => (
            <SingleSelect
              onSelect={onChange}
              value={value}
              label="Second"
            >
              <option value="fourth">Fourth</option>
              <option value="fifth">Fifth</option>
              <option value="sixth">Sixth</option>
            </SingleSelect>
          )
        }
      />
      <Button type="submit" color="info" style={{ marginTop: '20px' }}>
        Submit form
      </Button>
    </form>
  )
}`,
    },
  ],
};
